import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

let Tid;

const fetchSuiteSchedule = async () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getSchedule&companyid=${user.companyid}&suiteid=${Tid}`,
  );

  return response.data;
};

const useGetScheduleQuery = () => {
  const query = useQuery({
    queryKey: ["getSuiteSchedule"],
    queryFn: () => {
      return fetchSuiteSchedule(Tid);
    },
    enabled: false,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });

  const refetchWithParams = (id) => {
    Tid = id;
    query.refetch();
  };

  return {
    ...query,
    refetchWithParams,
  };
};

export default useGetScheduleQuery;
